import Vue from 'vue'
import Router from 'vue-router'
import TaskLog from '@/components/Tasklog'
import Logs from '@/components/Logs'
import TwoPageAuth from '@/components/Auth/Phone'

import Console from '@/components/Layout/Console'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '',
      component: Console,
      children: [
        {
          name: 'logs',
          path: '/logs',
          component: Logs
        },
        {
          name: 'tasks',
          path: '/',
          component: TaskLog
        }
      ]
    },
    {
      name: 'login',
      path: '/login',
      component: TwoPageAuth
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js